export const RECIPES_RECEIVED = 'RECIPES_RECEIVED';

export function recipesReceived(recipes) {
    return {
        type: RECIPES_RECEIVED,
        recipes
    };
}




// WEBPACK FOOTER //
// ./src/store/recipes/actions.js